import { t } from "ttag";

import { WeightProgress } from "@/app/components/legacy-components";
import { usePortalUserStore } from "@/app/stores";
import type { ObjectValue } from "@/shared/models/legacy-types";
import { GraphIcon, JarOfPillsIcon, Tabs } from "@/shared/ui";
import { MyAgenda } from "./my-agenda";

const HOME_TAB = {
  MY_AGENDA: "my-agenda",
  PROGRESS_TRACKER: "progress-tracker",
} as const;
type HomeTab = ObjectValue<typeof HOME_TAB>;

const HOME_TAB_ICON = {
  [HOME_TAB.MY_AGENDA]: <JarOfPillsIcon className="size-4" />,
  [HOME_TAB.PROGRESS_TRACKER]: <GraphIcon className="size-4" />,
} as const;

const getHomeTabLabel = (homeTab: HomeTab) => {
  const HOME_TAB_LABEL = {
    [HOME_TAB.MY_AGENDA]: t`My agenda`,
    [HOME_TAB.PROGRESS_TRACKER]: t`Progress tracker`,
  } as const;

  return HOME_TAB_LABEL[homeTab];
};

export const HomeTabs = () => {
  const canAccessActiveWeightLossFeatures = usePortalUserStore(
    (state) => state.canAccessActiveWLFeatures,
  );

  const subscriptions =
    usePortalUserStore((state) => state.portalUser?.subscriptions) ?? [];

  const hasCompletedIntakeForm = subscriptions.some(
    ({ intakeFormCompleted }) => intakeFormCompleted,
  );

  return (
    <Tabs.Root
      defaultValue={HOME_TAB.MY_AGENDA}
      className="flex h-full flex-col"
    >
      <Tabs.List>
        {hasCompletedIntakeForm && (
          <Tabs.Trigger value={HOME_TAB.MY_AGENDA} className="gap-x-2">
            {HOME_TAB_ICON[HOME_TAB.MY_AGENDA]}
            {getHomeTabLabel(HOME_TAB.MY_AGENDA)}
          </Tabs.Trigger>
        )}

        {canAccessActiveWeightLossFeatures && (
          <Tabs.Trigger value={HOME_TAB.PROGRESS_TRACKER} className="gap-x-2">
            {HOME_TAB_ICON[HOME_TAB.PROGRESS_TRACKER]}
            {getHomeTabLabel(HOME_TAB.PROGRESS_TRACKER)}
          </Tabs.Trigger>
        )}
      </Tabs.List>

      <div className="grow py-6">
        {hasCompletedIntakeForm && (
          <Tabs.Content value={HOME_TAB.MY_AGENDA}>
            <MyAgenda />
          </Tabs.Content>
        )}

        {canAccessActiveWeightLossFeatures && (
          <Tabs.Content value={HOME_TAB.PROGRESS_TRACKER}>
            <WeightProgress />
          </Tabs.Content>
        )}
      </div>
    </Tabs.Root>
  );
};
